class FarloUiLightbox {
	constructor(element) {
		this.element = element;
		this.initializeLightboxContainer();
		this.lightbox = document.querySelector('.farlo-ui-lightbox');
		this.lightboxContent = this.lightbox.querySelector('.farlo-ui-lightbox__content');
		this.lightboxContentInner = this.lightbox.querySelector('.farlo-ui-lightbox__content-inner');
		this.closeButton = this.lightbox.querySelector('.farlo-ui-lightbox__close');
		this.backdrop = this.lightbox.querySelector('.farlo-ui-lightbox__backdrop');
		const youTubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;


		this.element.addEventListener('click', this.openLightbox.bind(this));
		this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
		this.backdrop.addEventListener('click', this.closeLightbox.bind(this));
		this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));
		this.element.setAttribute('aria-haspopup', 'dialog');
		this.lightbox.setAttribute('role', 'dialog');
		this.lightbox.setAttribute('aria-modal', 'true');
		this.lightbox.setAttribute('aria-hidden', 'true');
		this.closeButton.setAttribute('aria-label', 'Close Lightbox');
		
	}

	helperIsImageType(src) {
		return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(src);
	}

	helperValueNullOrUndefined(checkedElement) {
		return checkedElement && typeof checkedElement !== 'undefined' && typeof checkedElement.value !== 'undefined' && checkedElement.value !== '';
	}

	initializeLightboxContainer() {
		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .farlo-ui-lightbox__toggle, .wp-block-gallery');
		if (lightboxEmbed.length > 0) {
			const div = document.createElement('div');
			const divInner = document.createElement('div');
			const divInnerContent = document.createElement('div');
			const divClose = document.createElement('button');
			const divBackdrop = document.createElement('div'); 
			div.className = 'farlo-ui-lightbox';
			divInner.className = 'farlo-ui-lightbox__inner';
			divInnerContent.className = 'farlo-ui-lightbox__content-inner';
			divClose.className = 'farlo-ui-lightbox__close';
			divBackdrop.className = 'farlo-ui-lightbox__backdrop';
			
			
			div.appendChild(divInner);
			divInner.appendChild(divInnerContent);
			divInner.appendChild(divClose);
			div.appendChild(divBackdrop); 
			document.body.appendChild(div);
		}
	}

	openLightbox() {
		
		const contentContainer = this.element.parentNode.querySelector('.farlo-ui-lightbox__html');
	
		if (contentContainer && contentContainer.innerHTML.trim() !== '') {
			const content = contentContainer.innerHTML;
			this.lightboxContentInner.innerHTML = content;
			this.lightbox.classList.add('farlo-ui-lightbox--active');
			this.lightbox.removeAttribute('aria-hidden');
			this.lightbox.setAttribute('tabindex', '-1'); // Make it focusable
			this.lightbox.focus();
	
			// Ensure Flickity is initialized or resized after content is shown
			const galleryContainer = this.lightboxContentInner.querySelector('.gallery__container');
			if (galleryContainer) {
				// Reinitialize Flickity for the gallery (assuming Flickity is already initialized elsewhere)
				const flktyGallery = new Flickity(galleryContainer, {
					cellAlign: 'left',
					contain: true,
					wrapAround: true,
					groupCells: false,
					pageDots: false,
					prevNextButtons: false,
					autoPlay:4000,
				});
	
				flktyGallery.resize(); // Resize Flickity once the lightbox is open
			}
		} else {
			console.error('Hidden div with class farlo-ui-lightbox__html not found or empty.');
		}
	}
	closeLightbox() {
		this.lightbox.classList.remove('farlo-ui-lightbox--active');

		setTimeout(() => {
			if (!this.element.nextElementSibling && !this.element.nextElementSibling.childNodes && !this.element.nextElementSibling.classList.contains('farlo-ui-lightbox')) {
				this.lightboxContentInner.innerHTML = '';
			}
			this.lightbox.setAttribute('aria-hidden', 'true');
			this.element.focus();
		}, 300);
	}

	handleKeydown(event) {
		if (event.key === 'Escape') {
			this.closeLightbox();
		}
	}
}

export default FarloUiLightbox;
